import ModulesLoading from "theme/libs/wordpress/content/ModulesLoading";
import React from "react";
import loadable from "@loadable/component";

const MODULES = {
    default: loadable(() => import("theme/libs/wordpress/content/cmsModules/default/FlexibleModule"), {
        fallback: <ModulesLoading ratio={[360 / 470, 768 / 860, 1366 / 616, null, 1930 / 830]} />,
    }),
    hero: loadable(() => import("theme/libs/wordpress/content/cmsModules/default/FlexibleModule"), {
        fallback: <ModulesLoading ratio={[6 / 5, null, 2, 3]} />,
    }),
};

const FlexiblePlaceholder = (props) => {
    const FlexibleModule = props.isHero ? MODULES["hero"] : MODULES["default"];

    return <FlexibleModule {...props} />;
};

FlexiblePlaceholder.propTypes = {};

export default FlexiblePlaceholder;
